import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faGift as fasGift,
    faCog,
    faColumns,
    faPlusCircle,
    faGripVertical,
    faCogs,
    faPaintBrush,
    faChevronDown,
    faChevronUp,
    faChevronRight,
    faDesktop,
    faTabletAlt,
    faMobileAlt,
    faDesktopAlt,
    faFillDrip,
    faAdjust,
    faImage,
    faVideo,
    faMagic,
    faInfoCircle,
    faCheck,
    faTrashAlt,
    faEllipsisV,
    faEllipsisH,
    faBan,
    faDoNotEnter as fasDoNotEnter,
    faCheckCircle as fasCheckCircle,
    faTimesCircle as fasTimesCircle,
    faExclamationCircle as fasExclamationCircle,
} from '@getanwar/pro-solid-svg-icons';
import {
    faHdd,
    faEdit,
    faSave,
    faPlus,
    faBars,
    faPlug,
    faLink,
    faClock,
    faTools,
    faClone,
    faTrash,
    faBooks,
    faTimes,
    faMinus,
    faEraser,
    faUnlink,
    faUpload,
    faLockAlt,
    faSignOut,
    faEnvelope,
    faExchange,
    faAlignLeft,
    faLayerPlus,
    faAlignRight,
    faAlignCenter,
    faAlignJustify,
    faArrowsAlt,
    faBorderAll,
    faUserCircle,
    faFileExport,
    faFileImport,
    faPaperPlane,
    faLayerGroup,
    faLaptopCode,
    faEyeDropper,
    faUserHeadset,
    faEye as faEyeR,
    faCog as faCogR,
    faClipboardList,
    faLongArrowLeft,
    faLongArrowRight,
    faCogs as farCogs,
    faPencilPaintbrush,
    faGlobe as farGlobe,
    faSpinner as faSpinnerR,
    faTrashAlt as faTrashAltR,
    faUserSlash as farUserSlash,
    faEllipsisV as faEllipsisVR,
    faUserShield as farUserShield,
    faChevronRight as faChevronRightR,
    faChevronUp as farChevronUp,
    faChevronDown as farChevronDown,
} from '@getanwar/pro-regular-svg-icons';
import {
    faEye,
    faSpinner,
    faEllipsisHAlt,
    faSave as falSave,
    faCopy as faCopyL,
    faRedo as falRedo,
    faUndo as falUndo,
    faTools as falTools,
    faCheck as falCheck,
    faTimes as faTimesL,
    faImage as falImage,
    faLayerPlus as falLayerPlus,
    faExternalLink as falExternalLink,
    faPencilPaintbrush as falPencilPaintbrush,
} from '@getanwar/pro-light-svg-icons';

import {
    faIcons,
    faGripLines,
    faLink as fadLink,
    faBars as fadBars,
    faCode as fadCode,
    faBullseyePointer,
    faImage as fadImage,
    faHeading as fadHeading,
    faMailBulk as fadMailBulk,
    faAlignLeft as fadAlignLeft,
    faStopwatch as fadStopwatch,
    faVideoPlus as fadVideoPlus,
    faArrowsAltV as fadArrowsAltV,
    faLaptopCode as fadLaptopCode,
    faEnvelopeOpenText as fadEnvelopeOpenText,
} from '@getanwar/pro-duotone-svg-icons';

export default function loadIcons() {
    library.add(
        // Duetone
        fadBars,
        fadLink,
        faIcons,
        fadCode,
        fadImage,
        fadHeading,
        faGripLines,
        fadMailBulk,
        fadStopwatch,
        fadAlignLeft,
        fadVideoPlus,
        fadLaptopCode,
        fadArrowsAltV,
        faBullseyePointer,
        fadEnvelopeOpenText,

        // Light
        falSave,
        falRedo,
        falUndo,
        falCheck,
        falImage,
        falLayerPlus,
        falExternalLink,

        // Solid
        faBan,
        fasGift,
        fasDoNotEnter,
        fasCheckCircle,
        fasTimesCircle,
        fasExclamationCircle,

        // Regular
        farCogs,
        farGlobe,
        farChevronUp,
        farUserSlash,
        farChevronDown,

        faEye,
        faCog,
        faHdd,
        faEdit,
        faPlug,
        faPlus,
        faLink,
        faCogR,
        faSave,
        faEyeR,
        faCogs,
        faBars,
        faClock,
        faClone,
        faTools,
        faTrash,
        faBooks,
        faCopyL,
        faCheck,
        faVideo,
        faMagic,
        falTools,
        faMinus,
        faTimes,
        faEraser,
        faAdjust,
        faImage,
        faUnlink,
        faTimesL,
        faUpload,
        faLockAlt,
        faSpinner,
        faSignOut,
        faDesktop,
        faColumns,
        faFillDrip,
        faTrashAlt,
        faEnvelope,
        faSpinnerR,
        faEllipsisV,
        faEllipsisH,
        faTabletAlt,
        faExchange,
        faAlignLeft,
        faLayerPlus,
        faAlignRight,
        faAlignCenter,
        farUserShield,
        faAlignJustify,
        faTrashAltR,
        faMobileAlt,
        faBorderAll,
        faArrowsAlt,
        faPlusCircle,
        faEllipsisVR,
        faChevronUp,
        faFileExport,
        faFileImport,
        faUserCircle,
        faInfoCircle,
        faPaintBrush,
        faLayerGroup,
        faPaperPlane,
        faLaptopCode,
        faDesktopAlt,
        faEyeDropper,
        faUserHeadset,
        faEllipsisHAlt,
        faGripVertical,
        faChevronDown,
        faChevronRight,
        faClipboardList,
        faLongArrowLeft,
        faChevronRightR,
        faLongArrowRight,
        faPencilPaintbrush,
        falPencilPaintbrush
    );
}
